// extracted by mini-css-extract-plugin
module.exports = {"limitedText":"ReadFullNote_limitedText__2OjMx","overflowing":"ReadFullNote_overflowing__1aVrC"};